import { useCallback, useState } from 'react';

import { Link } from '@chakra-ui/react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { useStyledToast } from 'components/Toast';

import { uploadDepositClientFilesAtom } from '../atoms/activeDepositsAtom';

export const useUploadDepositClientFiles = (id: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const uploadDepositFiles = useSetAtom(uploadDepositClientFilesAtom);
  const toast = useStyledToast();
  const { t } = useTranslation('payments');

  const onUploadComplete = useCallback(
    async (files: FormData) => {
      setIsLoading(true);
      try {
        await uploadDepositFiles({ id, files });
        toast({
          title: t('payment_upload_success'),
          variant: 'SUCCESS',
          description: t('payment_upload_success_description'),
          duration: 9000,
        });
      } catch (error) {
        console.log(error);
        toast({
          title: t('payment_upload_error'),
          description: (
            <Link onClick={() => onUploadComplete(files)}>
              {t('common:retry')}
            </Link>
          ),
          variant: 'ERROR',
          duration: 9000,
        });
      }
      setIsLoading(false);
    },
    [id, toast, t, uploadDepositFiles],
  );

  return { isUploadLoading: isLoading, onUploadComplete };
};
